<template>
  <div class="container">
    <v-btn icon="mdi-content-save" class="saveButton" @click="saveWorkshop"></v-btn>
    <v-btn icon="mdi-skip-forward" class="stopButton" @click="next"></v-btn>
    <v-btn icon="mdi-skip-backward" class="backButton" @click="back"></v-btn>
    <v-data-table :headers="tableHeaders" :items="tableData" class="table" style="padding-left: 30px; padding-right: 30px;">
      <template v-slot:[`item.qualityAspect`]="{ item }">
        <span style="text-align: left; font-weight: bold">
          {{item.qualityAspect}}
        </span>
      </template>
      <template v-slot:[`item.voteWhereWantToBe`]="{ item }">
        <span style="text-align: left; font-weight: bold">
          {{item.voteWhereWantToBe}}(<span style="text-align: left; font-weight: bold; color: red">{{item.voteWhereWeAre}}</span>)
        </span>
      </template>
      <template v-slot:[`item.recommendations`]="{ item }">
        <div class="ideas" style="text-align: left" v-for="(idea, ideaIndex) in item.recommendations" :key="'idea_'+ideaIndex">
          <div v-html="idea"></div>
        </div>
      </template>
      <template v-slot:[`item.measures`]="{ item }">
        <div>
          <v-list>
            <v-list-item
                class="task"
            >
              <v-text-field v-model="item.newmeasures"
                            label="Add New Task"
                            filled
                            outlined
                            shaped
                            dense
                            append-icon="mdi-view-grid-plus-outline"
                            @click:append="addNewTask(item)"
                            @keyup.enter="addNewTask(item)"></v-text-field>
            </v-list-item>
            <v-list-item
                v-for="(task, index) in filterTasksByQualityAspect(item.qualityAspect)"
                class="task"
                :key="index"
            >
              <span>{{task.summary}}</span>
            </v-list-item>
          </v-list>
        </div>
      </template>
      <template v-slot:[`item.priority`]="{ item }">
        <v-select class="tableSelect" v-model="item.priority" :items="['High', 'Medium', 'Low']"></v-select>
      </template>
      <template v-slot:[`item.effortEstimation`]="{ item }">
        <v-select class="tableSelect"  v-model="item.effortEstimation" :items="['XXS','XS','S','M','L','XL','XXL']"></v-select>
      </template>
    </v-data-table>
  </div>

</template>

<script>
import {addTask, loadTasks, loadWorkshop, saveWorkPlan} from "@/workshop/workshopFunctions";
import segmentData from '../data/segment.json'
import segmentSugesstionData from '../data/segmentSugesstion.json'

export default {
  name: "resultTable",
  components: {},
  data() {
    return {
      workshopData: {},
      tableHeaders: [
        { title: 'Quality Aspect', align: 'start', key: 'qualityAspect' },
        { title: 'Team Rating', align: 'center', key: 'voteWhereWantToBe' },
        { title: 'Ideas', align: 'center', key: 'recommendations' },
        { title: 'Tasks', align: 'center', key: 'measures' },
        /*{ title: 'Effort Estimation', align: 'center', key: 'effortEstimation' },*/
      ],
      tasks: [],
      tableData: [],
    };
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
    workshopId() {
      return this.$route.params.id;
    }
  },
  mounted() {
    loadTasks(this.customerId, this.workshopId).then(res => {
      this.tasks = res;
    });
    loadWorkshop(this.customerId, this.workshopId).then(res => {
      this.workshopData = res;
      this.loadData();
    });
  },
  methods: {
    async addNewTask(item){
      const newTask = {
        summary: item.newmeasures,
        qualityAspect: item.qualityAspect,
        assignee: "",
        parentIssue: "",
        dueDate: null,
        originalEffort: "",
        description: "",
        trackerKey: null,
        labels: [], // Labels als leeres Array initialisieren
        dirty: {
          summary: false,
          assignee: false,
          parentIssue: false,
          dueDate: false,
          originalEffort: false,
          description: false,
          qualityAspect: false,
        },
      };

      this.tasks.push(newTask);
      await addTask(this.customerId, this.workshopId, newTask);
      item.newmeasures = '';
    },
    saveWorkshop(){
      const newData = (this.workshopData.workPlan == undefined ? [] : [...this.workshopData.workPlan]).map(item => {
        if(this.tableData.map(i => i.id).includes(item.id)){
          const tableItem = this.tableData.find(i => i.id == item.id);
          return {
            id: item.id,
            priority: tableItem.priority,
            effortEstimation: tableItem.effortEstimation,
            measures: tableItem.measures
          }
        } else {
          return {
            id: item.id,
            priority: item.priority,
            effortEstimation: item.effortEstimation,
            measures: item.measures
          }
        }
      });
      this.tableData.forEach(item => {
        if(!newData.map(i => i.id).includes(item.id)){
          newData.push({
            id: item.id,
            priority: item.priority,
            effortEstimation: item.effortEstimation,
            measures: item.measures
          });
        }
      });
      saveWorkPlan(this.workshopId, newData).then(res => {
        console.log(res);
      });
    },
    next(){
      this.saveWorkshop();
      this.$emit('next', this.selected);
    },
    back(){
      this.$emit('back');
    },
    filterTasksByQualityAspect(qualityAspect) {
      if(this.tasks == undefined){
        this.tasks = [];
      }
      return this.tasks.filter((task) => task.qualityAspect === qualityAspect.replace(" ", "_"));
    },
    loadData() {
      const data = []
      for (const cat of [...segmentData]) {
        for(const subcat of cat.children){
          if(this.workshopData.selectedTopics.includes(subcat.id)) {
            let result = this.workshopData.results[subcat.id];
            let sugesstion = [...segmentSugesstionData].find(s => s.id == subcat.id);
            let priority = '';
            let effortEstimation = '';
            let measures = [];
            if(this.workshopData.workPlan != undefined && this.workshopData.workPlan.map(i => i.id).includes(subcat.id)){
              const item = this.workshopData.workPlan.find(i => i.id == subcat.id);
              priority = item.priority;
              effortEstimation = item.effortEstimation;
              measures = item.measures;
            }
            data.push({
                  id:subcat.id,
                  qualityAspect: subcat.text.en.name,
                  category: cat.text.en.name,
                  voteWhereWantToBe: result.voteWhereWantToBe,
                  voteWhereWeAre: result.voteWhereWeAre,
                  potential: result.voteWhereWantToBe - result.voteWhereWeAre,
                  recommendations: sugesstion.text.en.recommendations,
                  priority: priority,
                  effortEstimation: effortEstimation,
                  measures: measures,
                  newmeasures: ''
            });
          }
        }
      }
      this.tableData = data;
    }
  }
};
</script>

<style>
.tableSelect {
  width: 100%;
  height: 100%;
  display: block;
}
.tableSelect .v-input__control,
.textarea .v-input__control {
  width: 100%;
  height: 100%;
  display: inline-flex;
}
.tableSelect .v-input__control .v-field__input {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.tableSelect .v-input__control .v-field__input .v-select__selection{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.tableSelect .v-input__details,
.textarea .v-input__details {
  display: none;
}
.v-field--variant-filled .v-field__outline::before, .v-field--variant-underlined .v-field__outline::before {
  border-width: 0px;
}

.textarea {
  width: 100%;
  height: 100%;
  display: block;
}

.v-data-table__td{
  padding: 0!important;
}

.v-table tr th:nth-child(1),
.v-table tr td:nth-child(1) {
  width: 150px;
}

.v-table tr th:nth-child(2),
.v-table tr td:nth-child(2) {
  width: 20px;
}

.v-table tr th:nth-child(3),
.v-table tr td:nth-child(3) {
  width: 40%;
}

.v-table tr th:nth-child(5),
.v-table tr td:nth-child(5) {
  width: 150px;
  text-align: center;
}

.v-table tr th:nth-child(6),
.v-table tr td:nth-child(6) {
  width: 100px;
}

.v-table__wrapper {
  overflow: hidden;
}
.ideas .title{
  font-weight: bold;
  margin-right: 10px;
}
.ideas .bolder{
  font-weight: bold;
}

.saveButton {
  position: absolute;
  top: 20px;
  right: 20px;
}


.task {
}

.task textarea {
  margin-bottom: 20px;
}
.task .taskAssigned {
  position: absolute;
  right: 57px;
  bottom: 20px;
  width: 200px;
  height: 20px;
}
.task .taskAssigned >> .v-text-field input{
  color: black !important;
  height: 20px;
}
.task .v-input__details{
  display: contents;
}
</style>
